<template>
  <div class="widget-table-nested">
    <template v-for="(route, index) in tableData">
      <v-expansion-panel
        id="scheduleWidget"
        :key="route.id"
        v-model="expansionPanelValue[index]"
        :value="expansionPanelValue[index]"
      >
        <v-expansion-panel-content class="client-schedule-content">
          <v-icon slot="actions">
            keyboard_arrow_down
          </v-icon>
          <div slot="header" class="panel-header">
            <v-layout wrap align-center>
              <v-flex xs12 sm6 md4 class="schedule-route-name">
                {{ route.name }}
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                class="schedule-route-time"
                :class="{ active: !isCancelledRoute(route) }"
              >
                {{ route.startTime | dateFormat }}
                <span v-if="isCancelledRoute(route)"> - CANCELLED</span>
              </v-flex>
            </v-layout>
          </div>
          <v-card>
            <route-details-modal
              v-if="expansionPanelValue[index] === 0"
              :route-details="route"
              :hide-actions="true"
              :show-top-content="false"
            />
            <div v-else style="height: 20rem" />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import RouteDetailsModal from '../../modals/RouteDetailsModal.vue'
import {
  isDeclinedRoute,
  isNotScheduledType,
  isCancelledRoute
} from '../../../utils/routeUtils'

export default {
  components: { RouteDetailsModal },

  filters: {
    dateFormat: value => {
      return moment(value).format('dddd MM-DD-YY h:mm A')
    }
  },

  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      required: false,
      default: function() {
        return {
          hideHeaders: false,
          hideActions: false,
          expand: false
        }
      }
    }
  },

  data() {
    return {
      nestedTableHeader: [
        { text: 'Home Address', value: 'homeAddress', sortable: false },
        { text: 'Time', value: 'time', sortable: false }
      ],
      tableHeader: [{ text: '', value: 'name' }],
      expansionPanelValue: []
    }
  },

  mounted() {
    this.expansionPanelValue = this.tableData.map(item => {
      return null
    })
  },

  methods: {
    getFilteredStops(routeData) {
      if (routeData && routeData.routeStops) {
        return routeData.routeStops.filter(stop => stop.state !== 'decline')
      }
      return []
    },

    isCancelledRoute(route) {
      return isCancelledRoute(route)
    },

    isDeclined(routeData) {
      return isDeclinedRoute(routeData) || isNotScheduledType(routeData)
    }
  }
}
</script>

<style lang="sass">
#scheduleWidget
  border-radius: 1.5rem
  box-shadow: none !important
  margin: 1rem

.client-schedule-content
  border-radius: 1.5rem
  margin-bottom: 1.5rem !important
  .v-expansion-panel__header
    text-align: left !important
    background: $hwayzec
    border-radius: 1rem 1rem 0 0
  .v-expansion-panel__body
    border-radius: 0rem 0rem 1rem 1rem
    border-top: none
    box-shadow: none
    border: solid $hwayzec 0.1rem
  .v-card
    border-radius: 0rem 0rem 1rem 1rem
    box-shadow: none

.panel-header
  align-items: center

.schedule-route-time
  text-align: center
  font-size: 1.4rem
  &.active
    color: $hwayzGreen

.toolbar-text
  font-size: $hwayzFont10pt
  padding-right: 50px

.schedule-route-name
  padding: 7px
  font-size: 1.3rem
</style>
